import { Component, Input } from "@angular/core";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { StaticServeModule } from "@core/static-serve/static-serve.module";

@Component({
  selector: "mdk-feature-introductions-item",
  standalone: true,
  imports: [CommonModule,NgOptimizedImage,StaticServeModule],
  templateUrl: "./feature-introductions-item.component.html",
  styleUrls: ["./styles/feature-introductions-item.component.mobile.scss","./styles/feature-introductions-item.component.desktop.scss"],
})
export class FeatureIntroductionsItemComponent {

  @Input() icon!: string;
  @Input() title!: string;
  @Input() description!: string;

}
